import { useContext, useEffect, useState } from 'react'
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { tokens } from "../../theme";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AlbumOutlinedIcon from '@mui/icons-material/AlbumOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import FeaturedVideoOutlinedIcon from '@mui/icons-material/FeaturedVideoOutlined';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import ConnectWithoutContactOutlinedIcon from '@mui/icons-material/ConnectWithoutContactOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import InsertChartOutlinedTwoToneIcon from '@mui/icons-material/InsertChartOutlinedTwoTone';
import PriceCheckOutlinedIcon from '@mui/icons-material/PriceCheckOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import ShortcutIcon from '@mui/icons-material/Shortcut';
import ForumIcon from '@mui/icons-material/Forum';
import CommentIcon from '@mui/icons-material/Comment';
import LeakAddIcon from '@mui/icons-material/LeakAdd';
import CampaignIcon from '@mui/icons-material/Campaign';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import SlideshowOutlinedIcon from '@mui/icons-material/SlideshowOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import OrderCommentIcon from '@mui/icons-material/AssistantOutlined';
import 'react-pro-sidebar/dist/scss/styles.scss';
import { UserContext } from '../../context/UserContext';

const Item = ({ title, to, icon, selected, setSelected, isCollapsed, setIsCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem active={selected === title} style={{ color: colors.grey[100] }} onClick={() => setSelected(title)} icon={icon}>
      <Typography>
        {title}
      </Typography>
      <Link to={to} onClick={() => { if (isCollapsed === false) { setIsCollapsed(true); } }} />
    </MenuItem>
  )
}

function Sidebar() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState("false");
  const [selected, setSelected] = useState("Panel");
  useEffect(() => {
    const selectedTitle = window.location.pathname.split("/").length > 3 ? window.location.pathname.split("/")[2] + "/" + window.location.pathname.split("/")[3] : window.location.pathname.split("/")[2];
    switch (selectedTitle) {
      case "brands":
        setSelected("Markalar");
        break;
      case "brand":
        setSelected("Markalar");
        break;
      case "statistics/users":
        setSelected("Kullanıcı Raporları");
        break;
      case "statistics/favorites":
        setSelected("Takipçi Raporları");
        break;
      case "statistics/coupons":
        setSelected("Kupon Raporları");
        break;
      case "statistics/earnings":
        setSelected("Kazanç Raporları");
        break;
      case "statistics/user-profits":
        setSelected("Kullanıcı Kâr Raporları");
        break;
      case "statistics/brands":
        setSelected("Marka Raporları");
        break;
      case "statistics/brands-table":
        setSelected("Marka Tablosu");
        break;
      case "ads":
        setSelected("Reklamlar");
        break;
      case "ad":
        setSelected("Reklamlar");
        break;
      case "questions":
        setSelected("Sorular");
        break;
      case "signup-settings":
        setSelected("Kayıt Formu Ayarları");
        break;
      case "shortcuts":
        setSelected("Kısayollar");
        break;
      case "users":
        setSelected("Kullanıcılar");
        break;
      case "user":
        setSelected("Kullanıcılar");
        break;
      case "orders":
        setSelected("Siparişler");
        break;
      case "order":
        setSelected("Siparişler");
        break;
      case "withdraws":
        setSelected("Siparişler");
        break;
      case "contact-messages":
        setSelected("İletişim Mesajları");
        break;
      case "influencers":
        setSelected("Influencerlar");
        break;
      case "influencer":
        setSelected("Influencerlar");
        break;
      case "partners":
        setSelected("Partnerler");
        break;
      case "partner":
        setSelected("Partnerler");
        break;
      case "admins":
        setSelected("Yöneticiler");
        break;
      case "comments":
        setSelected("Yorumlar");
        break;
      case "order-comments":
        setSelected("Sipariş Yorumları");
        break;
      case "ref-codes":
        setSelected("Referans Kodları");
        break;
      case "announcements":
        setSelected("Duyurular");
        break;
      case "payments":
        setSelected("Ödemeler");
        break;
      default:
        setSelected("Panel");
    }
  }, [])

  const { user } = useContext(UserContext);
  var nameAndSurname = "";
  if (user.type === "admin" || user.type === "influencer" || user.type === "partner" || user.type === "influencer_partner") {
    nameAndSurname = user.name.charAt(0).toUpperCase() + user.name.slice(1).toLowerCase() + " " + user.surname.charAt(0).toUpperCase() + user.surname.slice(1).toLowerCase();
  } else if (user.type === "brand") {
    nameAndSurname = user.user_name.charAt(0).toUpperCase() + user.user_name.slice(1).toLowerCase() + " " + user.user_surname.charAt(0).toUpperCase() + user.user_surname.slice(1).toLowerCase();
  }

  const [open, setOpen] = useState(false);
  const [openInviters, setOpenInviters] = useState(false);

  useEffect(() => {
    if (isCollapsed) {
      setOpen(false);
      setOpenInviters(false);
    }
  }, [isCollapsed])


  return (
    <Box position="fixed" height="100vh" zIndex="10" sx={{
      "& .pro-sidebar-inner": {
        background: `${colors.primary[400]} !important`
      },
      "& .pro-icon-wrapper": {
        backgroundColor: "transparent !important"
      },
      "& .pro-inner-item:hover": {
        color: "#868dfb !important"
      },
      "& .pro-menu-item.active": {
        color: "#6870fa !important"
      }
    }}>

      <ProSidebar collapsed={isCollapsed}>
        <Menu>
          {/* PANEL TITLE AND MENU ICON */}
          <MenuItem onClick={() => { setIsCollapsed(!isCollapsed) }}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100]
            }}>
            {!isCollapsed && (
              <Box display="flex" justifyContent="space-between" alignItems="center" ml="15px">
                <Typography variant="h3" color={colors.grey[100]}>
                  ALCAGO
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* USER */}
          {!isCollapsed && (
            <Box mb="25px" >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center">

                <img
                  alt="profile-user"
                  src={user.type === "admin" ? "../../assets/default-user.png" : (user.type === "influencer" ? user.profile_photo_link : user.logo_link)}
                  width="100px"
                  height="100px"
                  style={{ margin: "auto 0", cursor: "pointer", borderRadius: "50%" }} />
              </Box>

              <Box textAlign="center">
                <Typography variant='h3' color={colors.grey[100]} fontWeight="bold" sx={{ margin: "10px 0 0 0" }}>
                  {nameAndSurname}
                </Typography>
                <Typography variant='h5' color={colors.greenAccent[500]}>
                  {(user.type === "admin" || user.type === "influencer" || user.type === "partner") && user.type.charAt(0).toUpperCase() + user.type.slice(1)}
                  {(user.type === "influencer_partner") && "Influencer Partner"}
                  {user.type === "brand" && user.name.toUpperCase()}
                </Typography>
              </Box>
            </Box>
          )}

          {user.type === "admin" &&
            <Box pl={isCollapsed ? undefined : "10%"}>
              {user.dashboard_perm === 1 && <Item title="Panel" to="/admin-panel/" icon={<DashboardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.statistics_perm === 1 && <SubMenu title={<Typography>Raporlar</Typography>} style={{ color: (selected.endsWith("Raporları") || selected.endsWith("Tablosu")) ? "#6870fa" : colors.grey[100] }} onClick={() => { if (isCollapsed) { setIsCollapsed(false); } setOpen(!open); }} open={open} icon={<InsertChartOutlinedTwoToneIcon />}>
                <Item title="Kullanıcı Raporları" to="/admin-panel/statistics/users" icon={<Groups2OutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Kullanıcı Kâr Raporları" to="/admin-panel/statistics/user-profits" icon={<PriceCheckOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Marka Raporları" to="/admin-panel/statistics/brands" icon={<AlbumOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Marka Tablosu" to="/admin-panel/statistics/brands-table" icon={<AlbumOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Kupon Raporları" to="/admin-panel/statistics/coupons" icon={<CardGiftcardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Kazanç Raporları" to="/admin-panel/statistics/earnings" icon={<PaidOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Reklam İzlenme Raporları" to="/admin-panel/statistics/ad-watchs" icon={<SlideshowOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              </SubMenu>}
              {user.brands_perm === 1 && <Item title="Markalar" to="/admin-panel/brands" icon={<AlbumOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.ads_perm === 1 && <Item title="Reklamlar" to="/admin-panel/ads" icon={<FeaturedVideoOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.ads_perm === 1 && <Item title="Sorular" to="/admin-panel/questions" icon={<QuizOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.sign_up_settings_perm === 1 && <Item title="Kayıt Formu Ayaları" to="/admin-panel/signup-settings" icon={<FormatAlignCenterIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.shortcuts_perm === 1 && <Item title="Kısayollar" to="/admin-panel/shortcuts" icon={<ShortcutIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.users_perm === 1 && <Item title="Kullanıcılar" to="/admin-panel/users" icon={<Groups2OutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.orders_perm === 1 && <Item title="Siparişler" to="/admin-panel/orders" icon={<LocalGroceryStoreOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.contact_messages_perm === 1 && <Item title="İletişim Mesajları" to="/admin-panel/contact-messages" icon={<ForumIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.influencers_perm === 1 && <Item title="Influencerlar" to="/admin-panel/influencers" icon={<ConnectWithoutContactOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}

              {user.partners_perm === 1 && <SubMenu title={<Typography>Inviterlar</Typography>} style={{ color: (selected === "Brand Inviter" || selected === "Influencer Inviter") ? "#6870fa" : colors.grey[100] }} onClick={() => { if (isCollapsed) { setIsCollapsed(false); } setOpenInviters(!openInviters); }} open={openInviters} icon={<HandshakeOutlinedIcon />}>
                <Item title="Brand Inviter" to="/admin-panel/partners" icon={<HandshakeOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Influencer Inviter" to="/admin-panel/influencer-partners" icon={<HandshakeOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              </SubMenu>}

              {user.admins_perm === 1 && <Item title="Yöneticiler" to="/admin-panel/admins" icon={<AdminPanelSettingsOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.announcements_perm === 1 && <Item title="Duyurular" to="/admin-panel/announcements" icon={<CampaignIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              {user.payments_perm === 1 && <Item title="Ödemeler" to="/admin-panel/payments" icon={<AccountBalanceOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
            </Box>
          }

          {user.type === "brand" &&
            <Box pl={isCollapsed ? undefined : "10%"}>
              <Item title="Panel" to="/brand-panel/" icon={<DashboardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <SubMenu title={<Typography>Raporlar</Typography>} style={{ color: selected.endsWith("Raporları") ? "#6870fa" : colors.grey[100] }} onClick={() => { if (isCollapsed) { setIsCollapsed(false); } setOpen(!open); }} open={open} icon={<InsertChartOutlinedTwoToneIcon />}>
                <Item title="Takipçi Raporları" to="/brand-panel/statistics/favorites" icon={<AlbumOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Kupon Raporları" to="/brand-panel/statistics/coupons" icon={<CardGiftcardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Kazanç Raporları" to="/brand-panel/statistics/earnings" icon={<PaidOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              </SubMenu>
              <Item title="Reklamlar" to="/brand-panel/ads" icon={<FeaturedVideoOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Sorular" to="/brand-panel/questions" icon={<QuizOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Yorumlar" to="/brand-panel/comments" icon={<CommentIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              {user.show_order_comments === 1 && <Item title="Sipariş Yorumları" to="/brand-panel/order-comments" icon={<OrderCommentIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
              <Item title="Duyurular" to="/brand-panel/announcements" icon={<CampaignIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              {user.is_influencer === 1 && <Item title="Referans Kodları" to="/brand-panel/ref-codes" icon={<LeakAddIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
            </Box>
          }

          {user.type === "influencer" &&
            <Box pl={isCollapsed ? undefined : "10%"}>
              <Item title="Panel" to="/influencer-panel/" icon={<DashboardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <SubMenu title={<Typography>Raporlar</Typography>} style={{ color: selected.endsWith("Raporları") ? "#6870fa" : colors.grey[100] }} onClick={() => { if (isCollapsed) { setIsCollapsed(false); } setOpen(!open); }} open={open} icon={<InsertChartOutlinedTwoToneIcon />}>
                <Item title="Kullanıcı Raporları" to="/influencer-panel/statistics/users" icon={<Groups2OutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <Item title="Kazanç Raporları" to="/influencer-panel/statistics/earnings" icon={<PaidOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              </SubMenu>
              <Item title="Referans Kodları" to="/influencer-panel/ref-codes" icon={<LeakAddIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Duyurular" to="/influencer-panel/announcements" icon={<CampaignIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Ödemeler" to="/influencer-panel/payments" icon={<AccountBalanceOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
            </Box>
          }

          {user.type === "partner" &&
            <Box pl={isCollapsed ? undefined : "10%"}>
              <Item title="Panel" to="/partner-panel/" icon={<DashboardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <SubMenu title={<Typography>Raporlar</Typography>} style={{ color: selected.endsWith("Raporları") ? "#6870fa" : colors.grey[100] }} onClick={() => { if (isCollapsed) { setIsCollapsed(false); } setOpen(!open); }} open={open} icon={<InsertChartOutlinedTwoToneIcon />}>
                <Item title="Kazanç Raporları" to="/partner-panel/statistics/earnings" icon={<PaidOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              </SubMenu>
              <Item title="Referans Kodları" to="/partner-panel/ref-codes" icon={<LeakAddIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Duyurular" to="/partner-panel/announcements" icon={<CampaignIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Ödemeler" to="/partner-panel/payments" icon={<AccountBalanceOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
            </Box>
          }

          {user.type === "influencer_partner" &&
            <Box pl={isCollapsed ? undefined : "10%"}>
              <Item title="Panel" to="/influencer-partner-panel/" icon={<DashboardOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <SubMenu title={<Typography>Raporlar</Typography>} style={{ color: selected.endsWith("Raporları") ? "#6870fa" : colors.grey[100] }} onClick={() => { if (isCollapsed) { setIsCollapsed(false); } setOpen(!open); }} open={open} icon={<InsertChartOutlinedTwoToneIcon />}>
                <Item title="Kazanç Raporları" to="/influencer-partner-panel/statistics/earnings" icon={<PaidOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              </SubMenu>
              <Item title="Referans Kodları" to="/influencer-partner-panel/ref-codes" icon={<LeakAddIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Duyurular" to="/influencer-partner-panel/announcements" icon={<CampaignIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
              <Item title="Ödemeler" to="/influencer-partner-panel/payments" icon={<AccountBalanceOutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
            </Box>
          }
        </Menu>
      </ProSidebar>


    </Box>
  )
}

export default Sidebar